import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { withRetry } from 'ml-services-common-react';

const sendWithRetry = (endpoint, method, params, additionalHeaders) => withRetry(() => JsonRPCService.send(endpoint, method, params, additionalHeaders));

export default class ActivitiesService {
    static getActivitiesForUser(additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('gatewayActivity'),
            'getActivitiesForUser',
            [],
            additionalHeaders
        );
    }

    static getActivitiesForCurrentUserAndGroups(additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('gatewayActivity'),
            'getActivitiesForCurrentUserAndGroups',
            [],
            additionalHeaders
        );
    }

    static getActivitiesForPolicy(policyNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getActivitiesForPolicy', [policyNumber], additionalHeaders);
    }

    static getActivitiesForAccount(accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getActivitiesForAccount', [accountNumber], additionalHeaders);
    }

    static getActivitiesForJob(jobNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getActivitiesForJob', [jobNumber], additionalHeaders);
    }

    static getActivityPatternsFor(actPatternEntity, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getActivityPatternsFor', [actPatternEntity], additionalHeaders);
    }

    static getAssignableUserForActivity(actPatternEntity, id, activityPattern,
        additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getAssignableUserForActivity', [actPatternEntity, id, activityPattern], additionalHeaders);
    }

    static createNewActivity(activity, note, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'createNewActivity', [activity, note], additionalHeaders);
    }

    static createNoteForActivity(param, data, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'createNoteForActivity',
            [param, data], additionalHeaders);
    }

    static markActivityAsCompleted(activityPublicID, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'markActivityAsCompleted', [activityPublicID], additionalHeaders);
    }

    static reassignActivity(selectedUser, id, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'reassignActivity', [selectedUser, id], additionalHeaders);
    }

    static getTasksForUser(limit, searchRequestDTO, additionalHeaders) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getTasksForUser',
            [limit, searchRequestDTO],
            additionalHeaders);
    }

    static getActivitiesForUserML(limit, searchRequestDTO, additionalHeaders) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getActivitiesForUserML',
            [limit, searchRequestDTO],
            additionalHeaders);
    }

    static updateActivitySummary(activityDTO, additionalHeaders) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'updateActivitySummary',
            [activityDTO],
            additionalHeaders);
    }

    static getAssignableQueuesForActivity(actPatternEntity, id, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getAssignableQueuesForActivity', [actPatternEntity, id], additionalHeaders);
    }

    static getActivitiesForAccountML(accountNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getActivitiesForAccountML', [accountNumber], additionalHeaders);
    }

    static getOpenActivitySummariesForPolicy(policyNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getOpenActivitySummariesForPolicy', [policyNumber], additionalHeaders);
    }

    static getOpenActivitySummariesForAccount(policyNumber, additionalHeaders = {}) {
        return sendWithRetry(getProxiedServiceUrl('gatewayActivity'),
            'getOpenActivitySummariesForAccount', [policyNumber], additionalHeaders);
    }
}

